module.exports = new __parcel__URL__("shop_machines_plasma_cannon.e6467424.png").toString();